module.exports = __webpack_public_path__ + "img/Foto_ZimmermannEFZ-DDD-7338_2019.35f917cf.jpg";